import { useCallback } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { useRootStore } from 'stores/RootStore'
import { AutopilotUpgradeEntryModal } from 'components/AutopilotUpgradeEntryModal/AutopilotUpgradeEntryModal'
import { PurchaseContentCreditsModal } from 'components/Settings/TieredBilling/components/AutopilotDetails/components/PurchaseContentCreditsModal/PurchaseContentCreditsModal'
import { StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

interface PurchaseContentCreditsModalProps {
  price: StripePrice
  defaultBatchCount?: number
  closeOnSuccess?: boolean
  onSuccess?: () => void
  skipRedirect?: boolean
  [key: string]: any
}

interface ModalOptions {
  newStack?: boolean
  [key: string]: any
}

export const usePurchaseContentCreditsModal = () => {
  const { openModal } = useModals()
  const { tierUsageStore } = useRootStore()
  const { currentSubscription } = tierUsageStore

  const openPurchaseModal = useCallback(
    (props: PurchaseContentCreditsModalProps, options?: ModalOptions) => {
      if (currentSubscription?.status === 'active') {
        openModal(PurchaseContentCreditsModal, props, options)
      } else {
        openModal(AutopilotUpgradeEntryModal, { variant: 'out_of_credits', skipRedirect: props.skipRedirect }, options)
      }
    },
    [currentSubscription, openModal],
  )

  return openPurchaseModal
}
